import { render, staticRenderFns } from "./FinanceReportsProfitAndLossHistorical.vue?vue&type=template&id=59e5640c&scoped=true"
import script from "./FinanceReportsProfitAndLossHistorical.vue?vue&type=script&lang=js"
export * from "./FinanceReportsProfitAndLossHistorical.vue?vue&type=script&lang=js"
import style0 from "./FinanceReportsProfitAndLossHistorical.vue?vue&type=style&index=0&id=59e5640c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e5640c",
  null
  
)

export default component.exports